import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahCabang, getAllClient } from "stores";
import { getAllAnggotaCabang } from "stores";
import { getAllSupervisor } from "stores";
import { getAllAreaManager } from "stores";
import { ubahPenempatanSupervisor } from "stores";
import { ubahPenempatanAreaManager } from "stores";
import { getCabangKonvensional } from "stores";
function ListCabang() {
  const dispatch = useDispatch();
  // const [singleSelect, setSingleSelect] = React.useState("");
  const cabang = useSelector((state) => state.cabangReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const storeSpv = useSelector((state) => state.supervisorReducer);
  const storeAM = useSelector((state) => state.areaManagerReducer);
  const auth = useSelector((state) => state.authReducer);
  const [modalCabang, setModalCabang] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalPenempatanSupervisor, setModalPenempatanSupervisor] =
    React.useState(false);
  const [modalPenempatanAM, setModalPenempatanAM] = React.useState(false);
  const [namaCabang, setNamaCabang] = React.useState("");
  const [idCabang, setIdCabang] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [filterClient, setFilterClient] = React.useState(null);
  const [alamat, setAlamat] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientCbg, setIdClientCbg] = React.useState("");
  const [detailCabang, setDetailCabang] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [listSpv, setListSpv] = React.useState([]);
  const [listAM, setListAM] = React.useState([]);
  const [pilihSpv, setPilihSpv] = React.useState(null);
  const [pilihAM, setPilihAM] = React.useState(null);
  const [idSsBaru, setidSsBaru] = React.useState(null);
  const [idAmBaru, setidAmBaru] = React.useState(null);

  const itemsPerPage = 10;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (selectedOption) => {
    setFilterClient(selectedOption);
    getCabangKonvensional(dispatch, { idClient: selectedOption.value });
  };

  const submitCabang = () => {
    tambahCabang({
      cabang_id: idCabang,
      namaCabang: namaCabang,
      alamat: alamat,
      idClient: idClientCbg,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getCabangKonvensional(dispatch, { idClient: "" });
        } else if (response.data.status === 403) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const submitUbahPenempatanSS = () => {
    if (pilihSpv === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Supervisor tidak boleh kosong",
      });
    } else {
      ubahPenempatanSupervisor({
        idCabang: idCabang,
        idSsLama: cabang.listAllAnggotaCabang.listSupervisor[0].idUser,
        idSsBaru: idSsBaru,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihSpv(null);
          setidSsBaru(null);
          getCabangKonvensional(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUbahPenempatanAM = () => {
    // console.log("idCabang", idCabang, "idSsBaru", idAmBaru);
    // console.log(cabang.listAllAnggotaCabang.listAreaManager[0].idUser);
    if (pilihAM === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Area Manager tidak boleh kosong",
      });
    } else {
      ubahPenempatanAreaManager({
        idCabang: idCabang,
        idAmLama: cabang.listAllAnggotaCabang.listAreaManager[0].idUser,
        idAmBaru: idAmBaru,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihAM(null);
          setidAmBaru(null);
          getCabangKonvensional(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleModalClose = () => {
    setModalCabang(false);
    setPilihClient("");
    setIdClientCbg("");
    setIdCabang("");
    setAlamat("");
    setNamaCabang("");
    setPilihSpv("");
    setPilihAM("");
    setModalPenempatanSupervisor(false);
    setModalPenempatanAM(false);
  };

  React.useEffect(() => {
    let tmp =
      cabang.listCabangKonvensional &&
      cabang.listCabangKonvensional.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center flex-wrap">
              {/* 1. BUTTON DETAIL CABANG */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail Cabang</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    backgroundColor: "#F75D59",
                    border: "none",
                    color: "white",
                    marginTop: "5px",
                    marginBottom: "5px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                  onClick={() => {
                    setModalDetail(!modalDetail);
                    setDetailCabang(val);
                    getAllAnggotaCabang(dispatch, { idCabang: val._id });
                  }}
                >
                  <i className="fas fa-info" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>

              {/* 2. AREA KHUSUS ADMIN / SUPER ADMIN */}
              {(auth.role === "super admin" || auth.role === "admin") && (
                <>
                  {/* BUTTON UBAH PENEMPATAN SS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Ubah Penempatan SS</Tooltip>}
                  >
                    <Button
                      className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        backgroundColor: "#42CDC6",
                        border: "none",
                        color: "white",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                      onClick={() => {
                        setModalPenempatanSupervisor(
                          !modalPenempatanSupervisor,
                        );
                        getAllSupervisor(dispatch, { idClient: "" });
                        setIdCabang(val._id);
                        getAllAnggotaCabang(dispatch, { idCabang: val._id });
                      }}
                    >
                      <i
                        className="fas fa-map-pin"
                        style={{ fontSize: "15px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* BUTTON UBAH PENEMPATAN AM */}
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Ubah Penempatan AM</Tooltip>}
                  >
                    <Button
                      className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "10px",
                        backgroundColor: "#1D3557", // Diubah ke Navy agar lebih premium
                        border: "none",
                        color: "white",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                      onClick={() => {
                        setModalPenempatanAM(!modalPenempatanAM);
                        getAllAreaManager(dispatch, { idClient: "" });
                        setIdCabang(val._id);
                        getAllAnggotaCabang(dispatch, { idCabang: val._id });
                      }}
                    >
                      <i
                        className="fas fa-map-marked-alt"
                        style={{ fontSize: "15px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                </>
              )}
            </div>
          ),
        };
      });
    setListCabang(tmp);
  }, [cabang.listCabangKonvensional, auth]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeSpv.listSupervisor &&
      storeSpv.listSupervisor.map((val) => {
        tmp.push({
          value: val._id,
          label: val.nama,
        });
      });

    setListSpv(tmp);
  }, [storeSpv.listSupervisor]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeAM.listAreaManager &&
      storeAM.listAreaManager.map((val) => {
        tmp.push({
          value: val._id,
          label: val.nama,
        });
      });

    setListAM(tmp);
  }, [storeAM.listAreaManager]);

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTop: "1px solid #E3E6F0",
        minHeight: "50px",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF",
        textTransform: "uppercase",
        justifyContent: "center", // Header tetap di tengah
      },
    },
    rows: {
      style: {
        minHeight: "65px", // Memberi ruang vertikal yang pas
        "&:not(:last-child)": {
          borderBottom: "1px solid #E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
        justifyContent: "center",
      },
    },
  };

  const colCabang = [
    {
      name: "NO",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Informasi Cabang",
      minWidth: "280px",
      cell: (row) => (
        <div className="py-2 w-100 text-center">
          {/* Nama Cabang */}
          <div
            className="text-dark"
            style={{ fontSize: "15px", fontWeight: "800", lineHeight: "1.2" }}
          >
            {row.namaCabang}
          </div>

          {/* Kode Cabang - Ukuran diperbesar ke 12px */}
          <div className="mt-1 d-flex justify-content-center align-items-center">
            <span
              className="badge bg-light border text-dark px-2 py-1"
              style={{
                fontWeight: "700",
                fontSize: "12px", // Diperbesar sesuai permintaan
                letterSpacing: "0.5px",
                borderRadius: "6px",
                color: "#1D3557",
              }}
            >
              CODE: {row.cabang_id}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "Kategori",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <span
          className="badge px-3 py-2"
          style={{
            backgroundColor: row.kategoriCabang
              ?.toLowerCase()
              .includes("syariah")
              ? "#EBFBEE"
              : "#EBF2FF",
            color: row.kategoriCabang?.toLowerCase().includes("syariah")
              ? "#2F9E44"
              : "#364FC7",
            borderRadius: "8px",
            fontSize: "11px",
            fontWeight: "800",
            textTransform: "uppercase",
          }}
        >
          {row.kategoriCabang || "-"}
        </span>
      ),
    },
    {
      name: "Client / BPD",
      minWidth: "200px",
      center: true,
      cell: (row) => (
        <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
          <i className="fas fa-university mr-2 text-primary opacity-50"></i>
          {row.client}
        </div>
      ),
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      cell: (row) => row.action, // Menggunakan action squircle yang kita buat tadi
    },
  ];

  React.useEffect(() => {
    getCabangKonvensional(dispatch, { idClient: "" });
    getAllClient(dispatch);
    getAllSupervisor(dispatch, { idClient: "" });
    getAllAreaManager(dispatch, { idClient: "" });
  }, []);

  return (
    <>
      <Modal
        size="md"
        show={modalPenempatanAM || modalPenempatanSupervisor}
        onHide={() => {
          handleModalClose();
          setModalPenempatanAM(false);
          setModalPenempatanSupervisor(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className={`fas ${modalPenempatanAM ? "fa-user-tie" : "fa-user-shield"} fa-2x text-white`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3 className="fw-800 text-dark mb-1">Ubah Penempatan</h3>
            <p className="text-muted">
              Pilih personil baru untuk ditugaskan di cabang ini
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">
                  Pilih {modalPenempatanAM ? "Area Manager" : "Supervisor"}
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={modalPenempatanAM ? pilihAM : pilihSpv}
                  onChange={(value) => {
                    if (modalPenempatanAM) {
                      setPilihAM(value);
                      setidAmBaru(value.value);
                    } else {
                      setPilihSpv(value);
                      setidSsBaru(value.value);
                    }
                  }}
                  options={modalPenempatanAM ? listAM : listSpv}
                  placeholder={`Cari ${modalPenempatanAM ? "AM" : "Supervisor"}...`}
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={
                  modalPenempatanAM
                    ? submitUbahPenempatanAM
                    : submitUbahPenempatanSS
                }
              >
                UPDATE PENEMPATAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        scrollable
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-store fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Detail Informasi Cabang</h3>
            <p className="text-muted">
              Struktur personil dan informasi wilayah kantor
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              {/* INFO DASAR */}
              <div className="mb-4 pb-3 border-bottom">
                <Row className="mb-2">
                  <Col xs="4" className="text-muted fw-bold small">
                    BANK / BPD
                  </Col>
                  <Col xs="8" className="text-dark fw-bold">
                    : {detailCabang.client}
                  </Col>
                </Row>
                <Row>
                  <Col xs="4" className="text-muted fw-bold small">
                    NAMA CABANG
                  </Col>
                  <Col xs="8" className="text-dark fw-bold">
                    : {detailCabang.namaCabang}
                  </Col>
                </Row>
              </div>

              {/* LIST ANGGOTA CABANG */}
              <Row>
                {[
                  {
                    label: "Area Manager",
                    data: cabang.listAllAnggotaCabang.listAreaManager,
                    icon: "fa-user-tie",
                    key: "namaAreaManager",
                  },
                  {
                    label: "Supervisor",
                    data: cabang.listAllAnggotaCabang.listSupervisor,
                    icon: "fa-user-shield",
                    key: "namaSupervisor",
                  },
                  {
                    label: "Marketing",
                    data: cabang.listAllAnggotaCabang.listMarketing,
                    icon: "fa-ad",
                    key: "namaMarketing",
                  },
                ].map((item, idx) => (
                  <Col md="4" key={idx} className="mb-3">
                    <div
                      className="p-3 bg-light h-100"
                      style={{
                        borderRadius: "15px",
                        border: "1px solid #eef2f7",
                      }}
                    >
                      <h6 className="fw-bold text-primary mb-3 small">
                        <i className={`fas ${item.icon} mr-2`}></i>
                        {item.label}
                      </h6>
                      <ul className="list-unstyled mb-0">
                        {item.data && item.data.length > 0 ? (
                          item.data.map((val, i) => (
                            <li
                              key={i}
                              className="text-dark fw-600 mb-1"
                              style={{ fontSize: "13px" }}
                            >
                              <i
                                className="fas fa-check-circle text-success mr-2"
                                style={{ fontSize: "10px" }}
                              ></i>
                              {val[item.key]}
                            </li>
                          ))
                        ) : (
                          <li className="text-muted italic small fw-bold">
                            Belum ada anggota
                          </li>
                        )}
                      </ul>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalCabang}
        onHide={() => {
          handleModalClose();
          setModalCabang(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-plus-circle fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3 className="fw-800 text-dark mb-1">Tambah Cabang Baru</h3>
            <p className="text-muted">
              Daftarkan kantor cabang konvensional baru ke sistem
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form>
                <Row>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        ID Cabang
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setIdCabang(e.target.value)}
                        placeholder="Contoh: CBG-001"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Nama Cabang
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNamaCabang(e.target.value)}
                        placeholder="Masukkan Nama Cabang"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="12" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Alamat Kantor
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setAlamat(e.target.value)}
                        placeholder="Masukkan Alamat Lengkap"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  {auth.role === "super admin" && (
                    <Col md="12" className="mb-3">
                      <Form.Group>
                        <label className="fw-bold text-dark mb-2">
                          Pilih Client (Bank)
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClientCbg(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Button
                  className="btn-block p-3 mt-3 text-white"
                  style={{
                    border: "none",
                    backgroundColor: "#1D3557",
                    borderRadius: "15px",
                    fontWeight: "800",
                    boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                  }}
                  onClick={submitCabang}
                >
                  SIMPAN DATA CABANG
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <div className="px-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 mt-1">
          {/* mt-1 untuk memepetkan ke tab navigasi di atasnya */}
          <div>
            <h4
              className="fw-800 text-dark mb-0"
              style={{
                letterSpacing: "0.5px",
                fontSize: "1.5rem",
                fontWeight: "500",
              }}
            >
              LIST CABANG KONVENSIONAL
            </h4>
            <p className="text-muted small mb-0">
              Kelola dan pantau seluruh data kantor cabang
            </p>
          </div>

          {(auth.role === "super admin" || auth.role === "admin") && (
            <Button
              onClick={() => setModalCabang(!modalCabang)}
              className="btn-fill d-flex align-items-center shadow-sm mt-3 mt-md-0"
              style={{
                backgroundColor: "#1D3557",
                border: "none",
                borderRadius: "10px",
                padding: "8px 20px", // Padding diperkecil sedikit agar lebih slim
                fontWeight: "600",
              }}
            >
              <i className="nc-icon nc-simple-add mr-2"></i>
              <span>Tambah Cabang</span>
            </Button>
          )}
        </div>

        {/* ROW FILTER: Search & Select Client (Dibuat lebih ringkas) */}
        <Card
          className="border-0 shadow-sm mb-3"
          style={{ borderRadius: "15px", backgroundColor: "#F8F9FC" }}
        >
          <Card.Body className="p-2 px-3">
            {" "}
            {/* Padding p-2 agar card filter lebih tipis */}
            <Row className="align-items-center">
              {/* Search Bar */}
              <Col
                md={auth.role === "super admin" ? "7" : "12"}
                className="my-1"
              >
                <InputGroup
                  className="bg-white shadow-none border-0"
                  style={{ borderRadius: "10px", overflow: "hidden" }}
                >
                  <InputGroup.Prepend>
                    <InputGroup.Text className="bg-white border-0">
                      <i className="nc-icon nc-zoom-split fw-bold text-muted"></i>
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    className="border-0"
                    type="text"
                    value={searchText}
                    onChange={handleSearch}
                    placeholder="Cari Kode atau Nama Cabang..."
                    style={{
                      height: "40px",
                      fontSize: "14px",
                      boxShadow: "none",
                    }}
                  />
                </InputGroup>
              </Col>

              {/* Filter Client */}
              {auth.role === "super admin" && (
                <Col md="5" className="my-1">
                  <Select
                    classNamePrefix="react-select"
                    value={filterClient}
                    onChange={(selectedOption) =>
                      handleFilterChange(selectedOption)
                    }
                    options={[
                      { value: "", label: "Semua Client (All)" },
                      ...listClient,
                    ]}
                    placeholder="Pilih Client"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        minHeight: "40px",
                        height: "40px",
                        border: "none",
                        boxShadow: "none",
                      }),
                    }}
                  />
                </Col>
              )}
            </Row>
          </Card.Body>
        </Card>

        {/* TABLE SECTION */}
        <Card
          className="border-0 shadow-sm overflow-hidden"
          style={{ borderRadius: "15px" }}
        >
          <DataTable
            columns={colCabang}
            data={listCabang.filter(
              (row) =>
                row.cabang_id
                  .toLowerCase()
                  .includes(searchText.toLowerCase()) ||
                row.namaCabang.toLowerCase().includes(searchText.toLowerCase()),
            )}
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />
        </Card>
      </div>
    </>
  );
}

export default ListCabang;
